function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Alert, Descriptions, Select, message } from 'antd';
import { Spinner } from 'react-bootstrap';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;

var EditConsultation = function EditConsultation(_ref) {
  var check = _ref.check,
      handler = _ref.handler;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      formLoading = _useState2[0],
      setFormLoading = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      successMessage = _useState6[0],
      setSuccessMessage = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      isDataLoading = _useState8[0],
      setIsDataLoading = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      bilanOptions = _useState10[0],
      setBilanOptions = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      serviceTree = _useState12[0],
      setServiceTree = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      medicalExamId = _useState14[0],
      setMedicalExamId = _useState14[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setSuccessMessage('');
    setFormLoading(true);
    var formData = new FormData();
    formData.append('plaintes', values.plaintes);
    formData.append("id", check.id);
    formData.append('resume', values.resume);
    formData.append("conclusion", values.conclusion);
    formData.append("traitement", values.traitement);
    formData.append("customer_id", check.customer.id);
    axios.post(Common.baseApiUrl + 'editmedicalcheck', formData).then(function (response) {
      setFormLoading(false);

      if (response.data.status == 200) {
        setSuccessMessage('La consultation à été modifiée');
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
      setFormLoading(false);
    });
  };

  useEffect(function () {
    form.setFieldsValue({
      plaintes: check.plaintes,
      resume: check.resume,
      traitement: check.traitement,
      conclusion: check.conclusion
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: check != null ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 7,
            children: /*#__PURE__*/_jsxs(Form, {
              form: form,
              layout: "vertical",
              onFinish: onFinish,
              children: [/*#__PURE__*/_jsx(Form.Item, {
                name: "plaintes",
                rules: [{
                  required: true,
                  message: 'Ce champ est obligatoire'
                }],
                label: "Plainte",
                children: /*#__PURE__*/_jsx(TextArea, {
                  autoSize: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "resume",
                label: "Resum\xE9 examen clinique / para clinique",
                children: /*#__PURE__*/_jsx(TextArea, {
                  autoSize: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "traitement",
                label: "Traitement en cours",
                children: /*#__PURE__*/_jsx(TextArea, {
                  autoSize: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                name: "conclusion",
                label: "Conclusion",
                children: /*#__PURE__*/_jsx(TextArea, {
                  autoSize: true
                })
              }), /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  loading: formLoading,
                  type: "primary",
                  htmlType: "submit",
                  children: "Sauvegarder"
                })
              }), errorMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
                message: errorMessage,
                type: "error",
                banner: true
              }), successMessage.length != 0 && /*#__PURE__*/_jsx(Alert, {
                message: successMessage,
                type: "success",
                banner: true
              })]
            })
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 5,
            md: 5,
            children: [/*#__PURE__*/_jsxs(Descriptions, {
              labelStyle: {
                background: '#FCD013'
              },
              contentStyle: {
                background: '#FCD013'
              },
              column: 1,
              bordered: true,
              children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Nom",
                children: check.customer.lastname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Pr\xE9nom",
                children: check.customer.firstname
              }), /*#__PURE__*/_jsx(Descriptions.Item, {
                label: "Profession",
                children: check.customer.job
              })]
            }), /*#__PURE__*/_jsx("br", {})]
          })]
        })
      })
    }) : /*#__PURE__*/_jsx("p", {
      children: "Une erreur est survenue"
    })
  });
};

export default EditConsultation;